(function () {
  function tokenize(str) {
    return (str || '').toLowerCase().split(/[^a-z0-9]+/).filter(function (t) { return t.length >= 4; });
  }

  function getMediaTokens(item) {
    var alt = item.getAttribute('data-media-alt') || '';
    var src = item.getAttribute('data-media-src') || '';
    var filename = src.split('/').pop().split('?')[0].replace(/\.\w+$/, '');
    return tokenize(alt + ' ' + filename);
  }

  var originalSlidesCache = new WeakMap();

  function dedupeById(slides) {
    var seen = {};
    return slides.filter(function (slide) {
      var id = slide.getAttribute('data-media-id') || slide.outerHTML;
      if (seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function getOriginalSlides(swiper) {
    if (originalSlidesCache.has(swiper)) return originalSlidesCache.get(swiper);
    var originals = swiper.slides
      .filter(function (slide) { return !slide.classList.contains('swiper-slide-duplicate'); })
      .map(function (slide) { return slide.cloneNode(true); });
    originals = dedupeById(originals);
    originalSlidesCache.set(swiper, originals);
    return originals;
  }

  function applyFilterToSwiper(swiper, variantSku) {
    if (!swiper) return;
    var originals = getOriginalSlides(swiper);

    // Tính tần suất xuất hiện của từng token trong TOÀN BỘ ảnh gốc của sản phẩm này
    var tokenFreq = {};
    var slideTokensList = originals.map(function (slide) {
      var tokens = getMediaTokens(slide);
      tokens.forEach(function (t) { tokenFreq[t] = (tokenFreq[t] || 0) + 1; });
      return tokens;
    });
    var total = originals.length;

    // Bỏ qua token xuất hiện ở hơn 50% tổng số ảnh (từ chung/SEO, không có giá trị phân biệt màu)
    function isDiscriminating(token) {
      return total > 0 && (tokenFreq[token] || 0) / total <= 0.5;
    }

    var finalSlides = originals;
    if (variantSku) {
      var vTokens = tokenize(variantSku).filter(isDiscriminating);
      var matching = originals.filter(function (slide, idx) {
        var tokens = slideTokensList[idx];
        return vTokens.some(function (vt) { return tokens.indexOf(vt) !== -1; });
      });
      if (matching.length > 1) finalSlides = matching;
    }

    if (swiper.params.loop) {
      swiper.loopDestroy();
      swiper.params.loop = false;
    }
    swiper.removeAllSlides();
    swiper.appendSlide(finalSlides.map(function (s) { return s.outerHTML; }));
    swiper.updateSize();
    swiper.updateSlides();
    swiper.update();
    swiper.slideTo(0, 0);
  }

  function reinitPhotoswipe(scopeEl) {
    var mediaGallery = scopeEl.closest('product-info')
      ? scopeEl.closest('product-info').querySelector('media-gallery')
      : scopeEl.querySelector('media-gallery');
    if (mediaGallery && typeof mediaGallery.handlePhotoswipe === 'function') {
      try { mediaGallery.handlePhotoswipe(); } catch (e) { /* ignore */ }
    }
  }

  function filterGalleryBySku(variantSku, scopeEl) {
    if (!scopeEl) return;
    variantSku = (variantSku || '').trim();

    var mainContainer = scopeEl.querySelector('.swiper-container');
    if (!mainContainer || !mainContainer.swiper) return;
    var mainSwiper = mainContainer.swiper;

    applyFilterToSwiper(mainSwiper, variantSku);
    if (mainSwiper.thumbs && mainSwiper.thumbs.swiper) {
      applyFilterToSwiper(mainSwiper.thumbs.swiper, variantSku);
    }

    reinitPhotoswipe(scopeEl);
  }

  function getMainProductInfo() {
    return document.querySelector('product-info[data-initial-variant-sku]');
  }

  function getSelectedVariantSku(scopeEl) {
    if (!scopeEl) return null;
    var scriptTag = scopeEl.querySelector('variant-picker script[data-selected-variant]');
    if (!scriptTag) return null;
    try {
      var data = JSON.parse(scriptTag.textContent);
      return data && data.sku ? data.sku : null;
    } catch (e) {
      return null;
    }
  }

  document.addEventListener('variant:changed', function (evt) {
    var scopeEl = getMainProductInfo();
    if (!scopeEl) return;
    var sku = getSelectedVariantSku(scopeEl);
    if (!sku && evt.detail && evt.detail.variant) sku = evt.detail.variant.sku;
    filterGalleryBySku(sku, scopeEl);
  });

  document.addEventListener('DOMContentLoaded', function () {
    var productInfo = getMainProductInfo();
    if (productInfo) {
      setTimeout(function () {
        var sku = getSelectedVariantSku(productInfo) || productInfo.getAttribute('data-initial-variant-sku');
        filterGalleryBySku(sku, productInfo);
      }, 300);
    }
  });
})();